import { Box, FormHelperText, TextField, Typography } from "@mui/material";
import { UseFormGetFieldState, UseFormRegister, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ProjectSetupFormData } from "../project-setup-form-data";

export const MaxProjectDescriptionLength = 1500;
interface Props {
  register: UseFormRegister<ProjectSetupFormData>;
  getFieldState: UseFormGetFieldState<ProjectSetupFormData>;
  watch: UseFormWatch<ProjectSetupFormData>;
}

export function ProjectInfoStep(props: Props) {
  const { register, getFieldState, watch } = props;
  const { t } = useTranslation();
  const watchTitle = watch("title");

  return (
    <Box>
      <Typography variant="caption" color={"primary.main"}>
        {t("captions.projectNameRequired")}
      </Typography>
      <TextField
        data-testid="create-project-title"
        {...register("title", { required: true })}
        variant="filled"
        sx={{ width: "100%" }}
        label={t("project.projectSetup.info.name.input")}
        required
        inputRef={(input) => input && input.focus()}
        inputProps={{ maxLength: 40 }}
        error={Boolean(getFieldState("title").error)}
      />
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <FormHelperText variant="filled" error>
          {getFieldState("title").error ? t("project.projectSetup.info.name.error") : " "}
        </FormHelperText>
        <FormHelperText variant="filled">{watchTitle ? watchTitle.length : 0}/40</FormHelperText>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Box>
          <Typography variant="caption" color={"primary.main"}>
            {t("project.projectSetup.orderAndPieceworkNumber.captionOrdreNumber")}
          </Typography>
          <TextField
            data-testid="edit-project-order-and-piecework-number-ordre"
            {...register("orderNumber")}
            variant="filled"
            sx={{ width: "100%" }}
            label={t("project.projectSetup.orderAndPieceworkNumber.ordreNumber")}
            inputProps={{ maxLength: 15 }}
          />
        </Box>
        <Box>
          <Typography variant="caption" color={"primary.main"}>
            {t("project.projectSetup.orderAndPieceworkNumber.captionPieceworkNumber")}
          </Typography>
          <TextField
            data-testid="edit-project-order-and-piecework-number-piecework"
            {...register("pieceworkNumber")}
            variant="filled"
            sx={{ width: "100%" }}
            label={t("project.projectSetup.orderAndPieceworkNumber.pieceworkNumber")}
            inputProps={{ maxLength: 15 }}
          />
        </Box>
        <Box>
          <Typography variant="caption" color={"primary.main"}>
            {t("project.projectSetup.companyName.caption")}
          </Typography>
          <TextField
            data-testid="edit-project-company-name"
            {...register("companyName")}
            variant="filled"
            sx={{ width: "100%" }}
            label={t("project.projectSetup.companyName.label")}
            inputProps={{ maxLength: 15 }}
          />
        </Box>
      </Box>
    </Box>
  );
}
